import { render, staticRenderFns } from "./preview-button.vue?vue&type=template&id=36026b20&"
import script from "./preview-button.vue?vue&type=script&lang=ts&"
export * from "./preview-button.vue?vue&type=script&lang=ts&"
import style0 from "./preview-button.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports